export const AUTH_LOADING = 'auth/loading';
export const AUTH_SUCCESS = 'auth/success';
export const AUTH_FAIL = 'auth/fail';
export const AUTH_LOGOUT = 'auth/logout';
